/**
  * 环境变量
  * 0-本地 1-测试 2-正式
*/
const ENV = 2; 
export default ENV